'use client'

import { ServerErrorPanel } from '@/components/error/server-error-panel'

/** A failure of the app frame itself (the session, the user selector); the pages fail inside it. */
export default function Error({ retry }: { retry: () => void }) {
  return (
    <div className="flex min-h-screen w-full">
      <ServerErrorPanel retry={retry} />
    </div>
  )
}
